import { myScore } from '../../AboutHelpers.tsx';

function AboutMyScore(): JSX.Element {
  return (
    <div id="MyScore">
      <h3>My Score</h3>
      <p>
        My Score is a customizable new metric for Gene–Disease and Variant–Disease Associations. Users choose
        the evidence sources they prefer and assign weights to each selection. DISGENET automatically computes
        My score and ranks associations accordingly. What does it do?
        <ul>
          <li className="bullet-item">Ranks results based on your weighted evidence model</li>
          <li className="bullet-item">
            Filters associations to keep only those supported by your chosen sources
          </li>
          <li className="bullet-item">
            Makes prioritization transparent, reproducible, and aligned with internal standards
          </li>
        </ul>
        For example, you can define My Score based on the sources GENCC, UNIPROT and CLINICALTRIALS as:
      </p>
      <span>{myScore()}</span>
      <p>
        An association present in the three sources will have a My score value of 1. In contrast, another
        association reported by GENCC and UNIPROT but not by CLINICALTRIALS will have a My Score value of
        0.75.
      </p>
    </div>
  );
}

export default AboutMyScore;